import React from 'react'

const UserMinus: React.FC<DefaultPropsIcon> = (props) => {
  const { size = 20, onClick, className, color = '#6E7191' } = props

  return (
    <span className={['anticon', 'anticon-setting', className || ''].join(' ')} onClick={onClick}>
      <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7.5" cy="5.5" r="3" stroke={color} strokeWidth="1.8" />
        <path
          d="M2.5 16.5C2.5 13.35 4.55 11 8 11C9.25 11 10.3 11.3 11.15 11.82"
          stroke={color}
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path d="M13 15.5H18" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    </span>
  )
}

export default UserMinus
